import React, { useState } from "react";
import "./SidebarChat.css";
import { Avatar, IconButton } from "@material-ui/core";
import { useEffect } from "react";
import db from "./firebase";
import {Link} from 'react-router-dom'

function SidebarChat({ addNewChat, name, id }) {
  const [seed, setSeed] = useState();
  const [messages,setMessages] = useState();

  useEffect(() => {
    setSeed(Math.random() * 5000);
  }, []);

  useEffect(()=>{
    if(id){
        db.collection('rooms').doc(id).collection('messages').orderBy('timestamp','desc')
        .onSnapshot(snapshot=>{
            setMessages(snapshot.docs.map(doc=>{
                doc.data();
            }))
        })
    }
  },[id])

  const createChat = () => {
    const roomName = prompt("Please enter a name for chat");
    //do db stuff
    if(roomName){
    db.collection('rooms').add({
        name: roomName
    })
}
  };



  return !addNewChat ? (
      <Link to={`/rooms/${id}`}>
    <div className="sidebarChat">
      <Avatar src={`https://avatars.dicebear.com/api/male/${seed}.svg`} />
      <div className="sidebarChat__info">
        <h2>{name}</h2>
        <p>{ messages!==undefined? messages[0]?.message: '' } </p>
      </div>
    </div>
    </Link> 
  ) : (
    <div onClick={createChat} className="sidebarChat">
      <h2>Add new chat</h2>
    </div>
  );
}

export default SidebarChat;
